<template>
  <div class="title_block">
    <div class="logo" @click="Back_menu">
      <img src="../assets/logo-white.png" alt="" />
    </div>
    <div class="switch_button">
      <div class="all_button">
        <div
          v-if="user_leave.standardType == 1"
          :class="this.pageStats == 1 ? 'buttonClicks' : 'buttonClick'"
          @click="GoJiaGe()"
        >
          <span>价格与库存</span>
        </div>
        <div
            v-if="user_leave.financeType == 1"
            :class="this.pageStats == 5 ? 'buttonClicks' : 'buttonClick'"
            @click="goCaiWu()"
        >
          <span>应收款与发票</span>
        </div>
        <div
            v-if="user_leave.task == 1"
            :class="this.pageStats == 4 ? 'buttonClicks' : 'buttonClick'"
            @click="goRenWu()"
        >
          <span>内部协调</span>
        </div>
        <div
          v-if="user_leave.master_gear == 1"
          :class="this.pageStats == 2 ? 'buttonClicks' : 'buttonClick'"
          @click="GoZhuDang()"
        >
          <span>IC产品信息</span>
        </div>
        <div
          v-if="user_leave.competitive_products == 1"
          :class="this.pageStats == 3 ? 'buttonClicks' : 'buttonClick'"
          @click="goShiChang()"
        >
          <span>IC市场情报</span>
        </div>
         <div
          v-if="user_leave.competitive_products == 1||user_leave.standardType == 1"
          :class="this.pageStats == 6 ? 'buttonClicks' : 'buttonClick'"
          @click="goOrder()"
        >
          <span>订单中心</span>
        </div>


      </div>
    </div>
    <div class="button">
      <div class="user">
        <img src="../assets/Title_img/user.png" alt="" />
        <div class="userSpan">
          <span>你好 </span>
          <span>{{ userId }}</span>
        </div>
      </div>
      <div class="CloseLogin" @click="out_login">
        <img src="../assets/Title_img/close.png" alt="" />
        <span>退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: "",
      pageStats: " ",
      user_leave: {},
    };
  },

  mounted() {
    this.findUserID();
    this.getUser();
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面

    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  methods: {
    goOrder() {
      this.pageStats = 6;
      this.$router.push("/OrderPc");
    },
    Back_menu() {
      this.$router.push({
        name: "Main_menuComputer",
      });
    },
    GoJiaGe() {
      this.$router.push({
        name: "second_menuComputer_PriceAndInventory",
      });
    },
    GoZhuDang() {
      this.$router.push({
        name: "ICChanPinXinXi",
      });
    },
    goRenWu() {
      this.pageStats = 4;
      this.$router.push("/missionComputer");
    },
    goShiChang() {
      this.pageStats = 3;
      this.$router.push("/CompetitionRegistration");
    },
    goCaiWu() {
      this.pageStats = 5;
      this.$router.push("/FinanceComputer");
    },
    findUserID() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      this.userId = suser_id.name;
      console.log(this.userId);
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    out_login() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push("/");
    },
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style>
</style>
<style scoped>
.router-link-active {
  background-color: #18a575;
  justify-content: center;
  border-radius: 30px;
  height: 48px;
  width: 160px;
  margin-right: 30px;
  align-items: center;
  display: flex;
  flex-direction: row;
  color: #ffffff;
  text-decoration: none;
}
.logo {
  //margin-top: 14px;
  margin-left: 34px;
}

.logo img {
  width: 200px;
  margin-bottom: 12px;
}

.title_block {
  min-width: 1920px;
  height: 100px;
  background-color: #18a575;
  //background-image: url("../assets/headerLogo.png");
  //background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  margin-right: 30px;
  display: flex;
  flex-direction: row;
}

.button span {
  color: #ffffff;
}

.user {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.CloseLogin {
  display: flex;
  align-items: center;
}

.buttonClick span {
  color: #18a575;
  font-weight: 500;
}

.button img {
  margin-right: 10px;
}

.CloseLogin {
  margin-left: 30px;
}

.buttonClick {
  border: 1px solid #a3dbc8;
  background-color: #e8f6f1;
  justify-content: center;
  border-radius: 30px;
  height: 48px;
  width: 160px;
  margin-right: 30px;
  align-items: center;
  display: flex;
  flex-direction: row;
  color: #ffffff;
  text-decoration: none;
}

.buttonClicks {
  border: 1px solid #a3dbc8;
  background-color: #e8f6f1;
  justify-content: center;
  border-radius: 30px;
  height: 48px;
  width: 160px;
  margin-right: 30px;
  align-items: center;
  display: flex;
  flex-direction: row;
  color: #ffffff;
  text-decoration: none;
}

.buttonClicks span {
  color: #18a575;
  font-weight: 500;
}

.all_button {
  width: 100%;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.switch_button {
  justify-content: center;
  display: flex;
  flex-direction: row;
  width: 60%;
}
</style>
